'use client';
import { Typography } from '@mui/material';
import { PropsWithChildren, useState } from 'react';
import DarkThemeProvider from '../../providers/DarkThemeProvider';
import CookieBanner from './CookieBanner';
import GoogleTracking from './GoogleTracking';
import * as React from 'react';
import { FooterProps } from '../mainLayout/footer/types';
import { useTranslate } from '@jd/i18n';
import MetaTracking from './MetaTracking';
import Optional from '../Optional';

type Props = PropsWithChildren<{
  legal: FooterProps['legal'];
  tracking: FooterProps['tracking'];
}>;

const CookieSettings = ({ children, legal, tracking }: Props) => {
  const t = useTranslate('menu.nav');
  const [show, setShow] = useState<boolean | undefined>(undefined);
  const [consent, setConsent] = useState<boolean>();
  const onClick = () => {
    setShow(true);
  };
  React.useEffect(() => {
    const onScroll = () => {
      if (window.scrollY >= 100) {
        setShow((prev) => (prev === undefined ? false : prev));
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <>
      <Optional condition={!legal.hideBanner}>
        <DarkThemeProvider>
          <CookieBanner
            {...legal}
            setShow={setShow}
            setConsent={setConsent}
            show={show}
          />
        </DarkThemeProvider>
        <Typography
          color={'textPrimary'}
          sx={{ '&:hover': { textDecoration: 'underline' }, cursor: 'pointer' }}
          onClick={onClick}
        >
          {children || t('cookiesSettings')}
        </Typography>
      </Optional>
      <GoogleTracking
        gtmId={tracking.gtmId}
        gaId={tracking.gaId}
        needConsent={!legal.hideBanner}
        consent={consent}
      />
      <MetaTracking consent={consent} pixelId={tracking.pixelId} />
    </>
  );
};

export default CookieSettings;
